import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

export default function AdminLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

       /* async function check() {
            const res = await fetch("https://einblau.ee/backend/api/check-auth.php", {
                credentials:"include"
            })
            const data = await res.json();
            if (data.authorized == true) {
                window.location.href ="/admin"
            }
            console.log(data.authorized)
    };
     check();
*/
   

    async function handleLogin(e) {
        e.preventDefault();
        setError("");
    
        try {
            const res = await fetch("https://einblau.ee/backend/api/login.php", {
                method: "POST",
                credentials: "include", // allow cookies/session
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password })
            });


            const data = await res.json();

            if (!data.success) return setError(data.message);

            localStorage.setItem("adminToken", data.token);
            window.location.href = "/admin";
        } catch (err) {
            setError("Something went wrong :" + err)
        }
    }

    return (
        <div>
            <form onSubmit={handleLogin}>
                <h2>Admin Login</h2>
                <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
                <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <button type="submit">Login</button>
                {error && <p style={{color:"red"}}>{error}</p>}
            </form>
        </div>

        
    )
}